export enum ScreenSize {
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  SmallTablet = 'SmallTablet',
  Desktop = 'Desktop',
}

export enum ScreenSizeMaxWidth {
  Mobile = 640,
  SmallTablet = 768,
  Tablet = 832,
}
